import React from 'react';
import { Hexagon } from 'lucide-react';

const ClientLogos = () => {
  return (
    <section data-testid="client-logos-section" className="py-12 sm:py-16 bg-background border-y border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center gap-6">
          <p className="text-xs font-semibold tracking-widest uppercase text-muted-foreground text-center">
            Certified Dealer
          </p>
          <div className="flex items-center gap-4" data-testid="client-logo-0">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center">
              <Hexagon className="w-7 h-7 sm:w-8 sm:h-8 text-primary" strokeWidth={1.5} />
            </div>
            <span className="text-xl sm:text-2xl font-semibold text-foreground">
              Illumidel
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
